<template lang="pug">
.receipt-creation-stepper
  v-stepper.stepper(
    v-model="el"
    vertical)
    v-stepper-step(
      :complete="el > 1"
      step="1") 確認會員資料
    v-stepper-content(step="1")
      receipt-profile-update-form(
        :user="user"
        @cancel="$emit('cancel')"
        @submit-succeed="profileUpdated")
    v-stepper-step(
      :complete="el > 2"
      step="2") 開立電子收據
    v-stepper-content(step="2")
      receipt-creation-form(
        :user="user"
        @cancel="$emit('cancel')"
        @submit-succeed="receiptCreated")
    v-stepper-step(
      :complete="el > 3"
      step="3") 完成
    v-stepper-content(step="3")
      div(v-if="receipt")
        base-text-divider 收據資料
        base-field(
          label="收據建立時間"
          :value="receipt.creationTime | timestampFilter")
        base-field(
          label="流水號"
          :value="receipt.serialNumber")
        base-field(
          label="付款者"
          :value="receipt.payer.displayName")
        base-field(
          label="經手人"
          :value="receipt.payee.displayName")
        base-field(
          label="是否已開立紙本收據"
          :value="receipt.paperInvoiced ? '是' : '否'")
        base-text-divider 款項
        template(v-for="(item, index) in receipt.items")
          .subheading 【 項目{{ index + 1 }} 】
          base-field(
            label="年度"
            :value="item.year")
          base-field(
            label="類別"
            :value="getType(item)")
          base-field(
            label="金額"
            :value="item.payment")
        base-text-divider 總額
        .title.red--text.text-xs-center
          p {{ receipt.total }}
      .text-xs-center
        v-btn(
          color="indigo"
          large
          outline
          @click="complete") 確認
</template>

<script>
import { db } from "@/firebase";
import ReceiptProfileUpdateForm from "@/components/forms/ReceiptProfileUpdateForm.vue";
import ReceiptCreationForm from "@/components/forms/ReceiptCreationForm.vue";
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import BaseField from "@/components/core/BaseField.vue";
import RECEIPT_TYPES from "@/assets/tables/receipt_types.json";

export default {
  name: "ReceiptCreationStepper",
  components: {
    ReceiptProfileUpdateForm,
    ReceiptCreationForm,
    BaseTextDivider,
    BaseField
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      RECEIPT_TYPES,
      el: 0,
      receipt: null
    };
  },
  methods: {
    profileUpdated() {
      this.el = 2;
    },
    async receiptCreated(receiptId) {
      const receiptDoc = await db
        .collection("receipts")
        .doc(receiptId)
        .get();

      this.receipt = receiptDoc.data();
      this.el = 3;
    },
    complete() {
      this.$emit("update-succeed");
      this.$emit("cancel");
    },
    getType(item) {
      const type = this.RECEIPT_TYPES[item.type].text;
      const other = item.other ? `-${item.other}` : "";
      return `${type}${other}`;
    }
  }
};
</script>
<style lang="stylus" scoped>
.stepper
  .v-stepper__content
    @media (max-width: 500px)
      margin-left: 5px
</style>
